import {Component, OnInit} from '@angular/core';
import {Partner} from '../../../../models/partner';
import Commons from "../../commons";
import {AuthRESTService} from '../../../services/rest/auth-rest.service';
import {ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    selector: 'app-partner-edit',
    templateUrl: './partner-edit.component.html',
    styleUrls: ['./partner-edit.component.css']
})
export class PartnerEditComponent extends Commons implements OnInit {
	partner: Partner = new Partner();
	base64: { value: string } = { value: '' };
    allowedFileTypes: string = "image/x-png";

    errorMessage;

    constructor(private route: ActivatedRoute, private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
		super(toastr, translate);
	}

    ngOnInit() {
        this.route.params.subscribe(params => {
			this.rest.get(`configuration/partners/${params['id']}`).subscribe((response) => {
				this.partner = response;
				this.base64.value = this.partner.base64;
            }, err => this.errorHandler(err))
		});
	}

    save(): void {
        this.clearNotifications();
        this.partner.base64 = this.base64.value;
        this.rest.put('configuration/partners', this.partner).subscribe(() => {
			this.addSuccess('general.saved')
        }, err => this.errorHandler(err))
    }
}
